import Vue from "vue";
import moment from "moment";

Vue.filter("formatDate", function(value: string, format: string | undefined) {
  return FormatDate.format(value, format);
});

export module FormatDate {
  export function format(value: string, format?: string): string {
    var date = moment(value);
    format = format || "DD/MM/YYYY";
    return date.format(format);
  }

  export function forInput(value?: string): string {
    if (value === undefined || value === null || value === "") return "";
    const date = format(value, "YYYY-MM-DD");
    return date === "1900-01-01" || date === "0001-01-01" ? "" : date;
  }

  export function forApi(value?: string): string {
    if (value === undefined || value === null || value === "")
      return "1900-01-01";
    return format(value, "YYYY-MM-DD");
  }
}
